import clsx from "clsx";
import Modal from "@app/components/modal/modal.component";
import { PortalDialogProps } from "@app/services/modal.service";
import { useT } from "@app/contexts/preferences.context";
import { IcX } from "@app/components/icons";
import { iconBtn } from "@app/components/ui";

export type PcInfoKind = "how" | "terms";

const HOW: [string, string][] = [
  ["Chọn linh kiện và gửi yêu cầu", "Chọn thời gian thuê, số lượng và địa chỉ nhận hàng. Chưa trừ tiền ở bước này."],
  ["PCRENDER gọi lại cho bạn", "Xác nhận yêu cầu và hẹn giờ giao hàng qua điện thoại."],
  ["Nhận hàng, thanh toán và đặt cọc", "Kiểm tra linh kiện trước khi thanh toán tiền thuê và tiền cọc."],
  ["Trả linh kiện, nhận lại cọc", "PCRENDER đến nhận lại, kiểm tra và hoàn cọc."],
];

const TERMS = [
  "Tiền thuê tính từ ngày nhận hàng. Trả sớm không hoàn lại tiền thuê còn lại.",
  "Trả trễ tính thêm theo giá ngày.",
  "Linh kiện hư hỏng, mất tem hoặc thiếu phụ kiện sẽ bị trừ vào tiền cọc.",
  "Tiền cọc sẽ được hoàn lại sau khi trả sản phẩm và không phát sinh hư hỏng.",
];

/** Cách thức thuê / Điều khoản thuê linh kiện (2 nút trên đầu trang) */
function PcInfoModal({ portalDialogRef, portalData }: PortalDialogProps<{ kind: PcInfoKind }>) {
  const t = useT();
  const how = portalData?.kind !== "terms";

  return (
    <Modal onCancel={portalDialogRef.close} buttonCancelInChildren={false}>
      <div className="flex w-[min(520px,calc(100vw-32px))] flex-col text-fg">
        <div className="flex items-start justify-between gap-3 border-b border-line px-6 pb-4 pt-5">
          <h2 className="text-[19px] font-bold">{how ? t("Cách thức thuê linh kiện") : t("Điều khoản thuê linh kiện")}</h2>
          <button type="button" className={clsx(iconBtn, "!h-8 !w-8")} aria-label={t("Đóng")} onClick={() => portalDialogRef.close()}>
            <IcX className="h-4 w-4" />
          </button>
        </div>
        <div className="px-6 py-5">
          {how ? (
            <ol className="m-0 flex list-none flex-col gap-3.5 p-0">
              {HOW.map(([title, desc], i) => (
                <li key={title} className="grid grid-cols-[28px_1fr] items-start gap-2.5">
                  <span className="grid h-7 w-7 place-items-center rounded-full bg-brand-soft text-[13px] font-bold text-brand">
                    {i + 1}
                  </span>
                  <div>
                    <b className="block font-semibold">{t(title)}</b>
                    <span className="text-[13px] text-muted">{t(desc)}</span>
                  </div>
                </li>
              ))}
            </ol>
          ) : (
            <ul className="m-0 flex list-disc flex-col gap-2 pl-5 text-[13.5px] leading-snug text-muted">
              {TERMS.map((line) => (
                <li key={line}>{t(line)}</li>
              ))}
            </ul>
          )}
        </div>
      </div>
    </Modal>
  );
}

export default PcInfoModal;
